function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Attention = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "AttentionIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M13.04 2.276a2.091 2.091 0 0 0-2.08 0L4.04 6.245A2.061 2.061 0 0 0 3 8.032v7.936c0 .737.396 1.419 1.04 1.787l6.92 3.969a2.091 2.091 0 0 0 2.08 0l6.92-3.969A2.061 2.061 0 0 0 21 15.968V8.032c0-.737-.396-1.419-1.04-1.787l-6.92-3.969zm.21 14.467a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0zm-.13-3.576V6.5h-2.25v6.667h2.25z",
      clipRule: "evenodd"
    })
  }));
});
Attention.displayName = 'AttentionIcon';
export default Attention;